module.exports = __webpack_public_path__ + "static/media/cancel.298842cc.svg";